/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import { TableCell, TableRow } from "@mui/material";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../helper/currencyFormatter";
import classes from "./catalog.module.css";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import { Menu, MenuItem } from "@mui/material";
import Button from "../../../component/button";
import Chip from "@mui/material/Chip";
import {
  DeleteIconNew,
  EditIconNew,
  EditSpecialPrice,
  ViewIconNew,
  ExportIcon,
  CartIcon,
} from "../../../component/icons/icons";
import constants from "../../../helper/constants";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Draggable from "react-draggable";
import BusApiCall from "../../../helper/axios";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Loader from "../../../component/loader";
// import { makeStyles } from '@mui/styles';
import { useNavigate, useLocation } from "react-router-dom";

const ProductTable = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const [pushOfferingDialog, setPushOfferingDialog] = useState(false);
  const [childTenantsList, setChildTenantsList] = useState([]);
  const [selectedTenants, setSelectedTenants] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const useStyles = makeStyles({
  // 	resizablePaper: {
  // 		resize: 'both',
  // 		overflow: 'auto',
  // 		minWidth: 640,
  // 		minHeight: 200,
  // 		maxWidth: '90vw',
  // 		maxHeight: '90vh',
  // 		width: '60vw',
  // 	}
  // });
  // const classess = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePushOffering = () => {
    setPushOfferingDialog(true);
    getChildTenantsList();
  };
  const getChildTenantsList = () => {
    setIsLoading(true);
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
    )
      .then((res) => {
        let data = res.data;
        if (data.tenants && data.tenants.length > 0) {
          setChildTenantsList(data.tenants);
        } else {
          setChildTenantsList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleTenantSelection = (tenantId) => {
    setSelectedTenants((prev) => {
      if (prev.includes(tenantId)) {
        return prev.filter((id) => id !== tenantId);
      }
      return [...prev, tenantId];
    });
  };
  const toDataUrl = (url) => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };
  const pushOfferingToTenants = async (tenantIds) => {
    setIsLoading(true);
    const imageFilename = props.product.largeImageUrl?.split("/").pop() || "";
    const base64Image = await toDataUrl(
      constants.imageUrl + props.product.largeImageUrl,
    );
    var payload = {
      tenantIds: tenantIds,
      packageId: props.product.productOfferingId,
      productMainImage: imageFilename,
      productMainImageSource: base64Image,
    };
    BusApiCall("POST", `${constants.busInternalUrl}/packagedSolutions`, payload)
      .then((res) => {
        console.log("res", res);
        props.setErrorMessage(t("PUSH_OFFERING_SUCCESS"), true);
      })
      .catch((err) => {
        console.log("err", err);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(t("DEFAULT_ERROR_MESSAGE"), false);
        }
      })
      .finally(() => {
        setIsLoading(false);
        setPushOfferingDialog(false);
        setSelectedTenants([]);
        setChildTenantsList([]);
      });
  };
  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  const id = open ? "simple-popper" : undefined;

  return (
    <>
      <TableRow>
        {/* <TableCell style={{ cursor: 'pointer' }} onClick={() => navigate(props.providerType === "SALES_CHNL_PROVIDER" ? (props.solutionAction === "/myOfferings" ? `/viewProduct/${props.product.productOfferingId}?type=myOfferings` : `/viewProduct/${props.product.productOfferingId}?type=availableOfferings`) : `/product/${props.product.productOfferingId}`)}>
                    {props.product.productCode}
                </TableCell>
                <TableCell style={{ cursor: 'pointer' }} onClick={() => navigate(props.providerType === "SALES_CHNL_PROVIDER" ? (props.solutionAction === "/myOfferings" ? `/viewProduct/${props.product.productOfferingId}?type=myOfferings` : `/viewProduct/${props.product.productOfferingId}?type=availableOfferings`) : `/product/${props.product.productOfferingId}`)}>
                    {props.solutionAction ? props.product.productName : props.product.name}
                </TableCell>
                <TableCell style={{ cursor: 'pointer' }} onClick={() => navigate(props.providerType === "SALES_CHNL_PROVIDER" ? (props.solutionAction === "/myOfferings" ? `/viewProduct/${props.product.productOfferingId}?type=myOfferings` : `/viewProduct/${props.product.productOfferingId}?type=availableOfferings`) : `/product/${props.product.productOfferingId}`)}> */}
        <TableCell
          style={{ cursor: "pointer" }}
          onClick={() => {
            // Determine the navigation path and state
            let path = "";
            let state = undefined;

            if (props.providerType === "SALES_CHNL_PROVIDER") {
              if (props.solutionAction === "/myOfferings") {
                path = `/viewProduct/${props.product.productId}?type=myOfferings`;
              } else if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/viewProduct/${props.product.productOfferingId}?type=myOfferings`;
              } else {
                path = `/viewProduct/${props.product.productId}?type=availableOfferings`;
              }
            } else {
              if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/newOrder/${props.product.productOfferingId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              } else {
                path = `/newOrder/${props.product.productId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              }
            }

            // Navigate using correct v6+ syntax
            navigate(path, { state });
          }}

        >
          {props.product.productCode}
        </TableCell>
        <TableCell
          style={{
            cursor: "pointer",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
          }}
          onClick={() => {
            // Determine the navigation path and state
            let path = "";
            let state = undefined;

            if (props.providerType === "SALES_CHNL_PROVIDER") {
              if (props.solutionAction === "/myOfferings") {
                path = `/viewProduct/${props.product.productId}?type=myOfferings`;
              } else if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/viewProduct/${props.product.productOfferingId}?type=myOfferings`;
              } else {
                path = `/viewProduct/${props.product.productId}?type=availableOfferings`;
              }
            } else {
              if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/newOrder/${props.product.productOfferingId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              } else {
                path = `/newOrder/${props.product.productId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              }
            }

            // Navigate using correct v6+ syntax
            navigate(path, { state });
          }}

        >
          {props.solutionAction === "/product" ||
            props.solutionAction === "/newOrder" ||
            props.solutionAction === "/myOfferings"
            ? props.product.name
            : props.product.productName}
        </TableCell>
        <TableCell
          style={{
            cursor: "pointer",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
          }}
          onClick={() => {
            // Determine the navigation path and state
            let path = "";
            let state = undefined;

            if (props.providerType === "SALES_CHNL_PROVIDER") {
              if (props.solutionAction === "/myOfferings") {
                path = `/viewProduct/${props.product.productId}?type=myOfferings`;
              } else if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/viewProduct/${props.product.productOfferingId}?type=myOfferings`;
              } else {
                path = `/viewProduct/${props.product.productId}?type=availableOfferings`;
              }
            } else {
              if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/newOrder/${props.product.productOfferingId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              } else {
                path = `/newOrder/${props.product.productId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              }
            }

            // Navigate using correct v6+ syntax
            navigate(path, { state });
          }}

        >
          {props.product.description ? props.product.description : ""}
        </TableCell>
        <TableCell
          style={{ cursor: "pointer" }}
          onClick={() => {
            // Determine the navigation path and state
            let path = "";
            let state = undefined;

            if (props.providerType === "SALES_CHNL_PROVIDER") {
              if (props.solutionAction === "/myOfferings") {
                path = `/viewProduct/${props.product.productId}?type=myOfferings`;
              } else if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/viewProduct/${props.product.productOfferingId}?type=myOfferings`;
              } else {
                path = `/viewProduct/${props.product.productId}?type=availableOfferings`;
              }
            } else {
              if (
                props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder"
              ) {
                path = `/newOrder/${props.product.productOfferingId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              } else {
                path = `/newOrder/${props.product.productId}`;
                state = {
                  subscriptionData: props.subscriptionData || {},
                  offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                  availableCustomers: props.availableCustomers || [],
                };
              }
            }

            // Navigate using correct v6+ syntax
            navigate(path, { state });
          }}

        >
          {props.productCategory}
        </TableCell>
        {
          // props.screen !== "catalog" &&
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              // Determine the navigation path and state
              let path = "";
              let state = undefined;

              if (props.providerType === "SALES_CHNL_PROVIDER") {
                if (props.solutionAction === "/myOfferings") {
                  path = `/viewProduct/${props.product.productId}?type=myOfferings`;
                } else if (
                  props.solutionAction === "/product" ||
                  props.solutionAction === "/newOrder"
                ) {
                  path = `/viewProduct/${props.product.productOfferingId}?type=myOfferings`;
                } else {
                  path = `/viewProduct/${props.product.productId}?type=availableOfferings`;
                }
              } else {
                if (
                  props.solutionAction === "/product" ||
                  props.solutionAction === "/newOrder"
                ) {
                  path = `/newOrder/${props.product.productOfferingId}`;
                  state = {
                    subscriptionData: props.subscriptionData || {},
                    offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                    availableCustomers: props.availableCustomers || [],
                  };
                } else {
                  path = `/newOrder/${props.product.productId}`;
                  state = {
                    subscriptionData: props.subscriptionData || {},
                    offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                    availableCustomers: props.availableCustomers || [],
                  };
                }
              }

              // Navigate using correct v6+ syntax
              navigate(path, { state });
            }}

          >
            {/* {props.solutionAction === "/myOfferings" || props.solutionAction === "/availableOfferings" ? (
							props.product.isSubmittedForReview ? (
								props.userPerms.includes("CUMULATOR_PRODUCT_COMMIT") ? (
									<Chip size="normal" style={{ background: '#ffefcc', color: '#a78025', fontWeight: "600" }} label={t("PENDING_REVIEW")} />
								) : (
									<Chip size="normal" style={{ background: '#ffefcc', color: '#a78025', fontWeight: "600" }} label={t("PENDING_REVIEW")} />
								)
							) : !props.product.isApproved ? (
								<Chip size="normal" style={{ background: '#ffefcc', color: '#a78025', fontWeight: "600" }} label={t("APPROVE_ALERT_TEXT")} />
							) : (
								<Chip size="normal" style={{ background: '#c2f5da', color: '#178c4e', fontWeight: "600" }} label={t("APPROVED")} />
							)
						) : (
							<Chip size="normal" label={props.product.status} />
						)} */}
            <Chip
              size="normal"
              // style={{ background: "#c2f5da", color: "#178c4e", fontWeight: "600" }}
              className={
                props.product.status && props.product.status === "P_PUBLISHED"
                  ? "successChip"
                  : props.product.status &&
                    props.product.status === "P_REJECTED"
                    ? "errorChip"
                    : "inProgressChip"
              }
              label={
                props.product.statusDisplayName &&
                  props.product.statusDisplayName != ""
                  ? props.product.statusDisplayName
                  : "In Draft"
              }
            ></Chip>
          </TableCell>
        }
        {props.solutionAction === "/myOfferings" && (
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              // Determine the navigation path and state
              let path = "";
              let state = undefined;

              if (props.providerType === "SALES_CHNL_PROVIDER") {
                if (props.solutionAction === "/myOfferings") {
                  path = `/viewProduct/${props.product.productId}?type=myOfferings`;
                } else if (
                  props.solutionAction === "/product" ||
                  props.solutionAction === "/newOrder"
                ) {
                  path = `/viewProduct/${props.product.productOfferingId}?type=myOfferings`;
                } else {
                  path = `/viewProduct/${props.product.productId}?type=availableOfferings`;
                }
              } else {
                if (
                  props.solutionAction === "/product" ||
                  props.solutionAction === "/newOrder"
                ) {
                  path = `/newOrder/${props.product.productOfferingId}`;
                  state = {
                    subscriptionData: props.subscriptionData || {},
                    offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                    availableCustomers: props.availableCustomers || [],
                  };
                } else {
                  path = `/newOrder/${props.product.productId}`;
                  state = {
                    subscriptionData: props.subscriptionData || {},
                    offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                    availableCustomers: props.availableCustomers || [],
                  };
                }
              }

              // Navigate using correct v6+ syntax
              navigate(path, { state });
            }}

          >
            {props.product.isBundle && (
              <span style={{ fontSize: "13px", fontWeight: "600" }}>
                {t("STARTING_FROM_TEXT")}
              </span>
            )}

            <div>
              {props.solutionAction === "/product" ||
                props.solutionAction === "/newOrder" ||
                props.solutionAction === "/myOfferings" ? (
                <>
                  {currencyFormatter(props.product.price.priceAmount)}
                  {props.product.price.priceType === "RC" ? t("PER_MONTH") : ""}
                </>
              ) : (
                <>{currencyFormatter(props.product.startingPrice)}</>
              )}
            </div>
          </TableCell>
        )}

        {/* Actions start */}
        <TableCell style={{ width: "9rem" }}>
          {props.solutionAction !== "/newOrder" &&
            props.solutionAction !== "/product" ? (
            <>
              {props.solutionAction === "/myOfferings" &&
                props.menuPaths.includes("/newOrder/:id") &&
                props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                  <Button
                    style={{ width: "100%" }}
                    onClick={() => {
                      navigate(`/newOrder/${props.product.productId}`, {
                        state: {
                          subsciptionData: props.subsciptionData ? props.subsciptionData : {},
                          offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                          availableCustomers: props.availableCustomers || [],
                        },
                      });
                    }}

                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          marginRight: "5px",
                          position: "relative",
                          top: ".1rem",
                        }}
                      >
                        <CartIcon />
                      </span>
                      <span style={{ fontSize: "0.8rem" }}>
                        {props.quoteEnabled ? (
                          <>{t("CREATE_QUOTE")}</>
                        ) : (
                          <>{t("PLACE_ORDER")}</>
                        )}
                      </span>
                    </div>
                  </Button>
                )}
            </>
          ) : (
            <Link
              to={
                props.publicBrowsing
                  ? `/viewSolution/${props.product.productOfferingId}`
                  : `${location.pathname}/${props.product.productOfferingId}`
              }
              state={
                !props.publicBrowsing &&
                  props.providerType === "SOLUTION_PROVIDER" &&
                  (location.pathname === "/newOrder" || location.pathname === "/product")
                  ? {
                    subsciptionData: props.subsciptionData ? props.subsciptionData : {},
                    offeringCustomer: props.offeringCustomer,
                    parentTenantId: props.tenantId,
                    availableCustomers: props.availableCustomers || [],
                  }
                  : !props.publicBrowsing
                    ? {
                      subsciptionData: props.subsciptionData ? props.subsciptionData : {},
                      offeringCustomer: props.offeringCustomer,
                      availableCustomers: props.availableCustomers || [],
                      isLeadQuote: props.isLeadQuote || false,
                      leadData: props.leadData || {},
                    }
                    : undefined
              }
            >
              {props.providerType === "SALES_CHNL_PROVIDER" ||
                props.publicBrowsing ? (
                <>
                  {/* <Button>Place Order</Button> */}
                  {props.menuPaths.includes("/newOrder/:id") &&
                    props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                      <Button
                        onClick={() => {
                          navigate({
                            pathname: `/newOrder/${props.product.productOfferingId}`,
                            state: {
                              subsciptionData: props.subsciptionData
                                ? props.subsciptionData
                                : {},
                              offeringCustomer: props.product.isBundle
                                ? ""
                                : props.offeringCustomer,
                              availableCustomers: props.availableCustomers
                                ? props.availableCustomers
                                : [],
                              isLeadQuote: props.isLeadQuote
                                ? props.isLeadQuote
                                : false,
                              leadData: props.leadData ? props.leadData : {},
                            },
                          });
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "5px",
                              position: "relative",
                              top: ".1rem",
                            }}
                          >
                            <CartIcon />
                          </span>
                          <span style={{ fontSize: "0.8rem" }}>
                            {props.quoteEnabled ? (
                              <>{t("CREATE_QUOTE")}</>
                            ) : (
                              <>{t("PLACE_ORDER")}</>
                            )}
                          </span>
                        </div>
                      </Button>
                    )}
                </>
              ) : // <Button>View</Button>
                props.providerType === "SOLUTION_PROVIDER" &&
                  (location.pathname === "/newOrder" ||
                    location.pathname === "/product") &&
                  props.menuPaths.includes("/newOrder/:id") &&
                  props.userPerms.includes("ORDERMGR_SALES_CREATE") ? (
                  <Tooltip
                    title={
                      props.quoteEnabled ? t("CREATE_QUOTE") : t("PLACE_ORDER")
                    }
                  >
                    <svg
                      className={classes.addToCartIcon}
                      style={{ position: "initial" }}
                      viewBox="0 0 29 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        navigate(`/newOrder/${props.product.productOfferingId}`, {
                          state: {
                            subsciptionData: props.subsciptionData ? props.subsciptionData : {},
                            offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                            availableCustomers: props.availableCustomers || [],
                          },
                        });
                      }}

                    >
                      <path
                        d="M14.1872 16.1379H17.0247V11.5543H21.2808V8.4986H17.0247V3.91504H14.1872V8.4986H9.93105V11.5543H14.1872V16.1379ZM8.51233 29.8885C6.95173 29.8885 5.68907 31.2636 5.68907 32.9443C5.68907 34.6249 6.95173 36 8.51233 36C10.0729 36 11.3498 34.6249 11.3498 32.9443C11.3498 31.2636 10.0729 29.8885 8.51233 29.8885ZM22.6995 29.8885C21.1389 29.8885 19.8763 31.2636 19.8763 32.9443C19.8763 34.6249 21.1389 36 22.6995 36C24.2601 36 25.537 34.6249 25.537 32.9443C25.537 31.2636 24.2601 29.8885 22.6995 29.8885ZM8.75351 24.923L8.79607 24.7397L10.0729 22.2493H20.6424C21.7064 22.2493 22.6428 21.6229 23.1252 20.6756L28.6014 9.96534L26.1328 8.4986H26.1187L24.5581 11.5543L20.6424 19.1936H10.683L10.4985 18.7811L7.3206 11.5543L5.97282 8.4986L4.63922 5.44289H0V8.4986H2.83744L7.94484 20.095L6.02956 23.8382C5.80257 24.266 5.67488 24.7702 5.67488 25.305C5.67488 26.9856 6.95173 28.3607 8.51233 28.3607H25.537V25.305H9.10819C8.92375 25.305 8.75351 25.1369 8.75351 24.923Z"
                        fill={props.tenantData.color}
                      />
                      <rect
                        x="9.93115"
                        y="3.91504"
                        width="11.3498"
                        height="12.2228"
                        fill="white"
                      />
                      <path
                        d="M24.2072 8.06904H20.4831V11.7932H19.2417V8.06904H15.5176V6.82766H19.2417V3.10352H20.4831V6.82766H24.2072V8.06904Z"
                        fill={props.tenantData.color}
                      />
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip title={t("VIEW")}>
                    <IconButton
                      color="primary"
                      aria-label="View"
                      component="span"
                      // className={classes.cardIconButton}
                      className="buttonSecondary"
                      style={{ color: props.tenantData.color }}
                    >
                      <ViewIconNew />
                      {/* <VisibilityIcon className={classes.cardIcon} /> */}
                    </IconButton>
                  </Tooltip>
                )}
            </Link>
          )}
        </TableCell>
        {props.screen !== "catalog" && (
          <TableCell>
            {props.providerType === "SALES_CHNL_PROVIDER" ||
              props.providerType === "SOLUTION_PROVIDER" ? (
              props.solutionAction === "/myOfferings" ? (
                props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                  <>
                    {props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                      props.userPerms.includes("CATALOG_CREATE") ||
                      props.userPerms.includes("CATALOG_ADMIN") ? (
                      <React.Fragment>
                        <>
                          <Button
                            style={{ padding: "2px 8px" }}
                            className={classes.button2}
                            aria-describedby={id}
                            type="button"
                            onClick={handleClick}
                          >
                            ...
                          </Button>
                          <Popper
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            placement="bottom-start"
                          >
                            <ClickAwayListener onClickAway={handleClose}>
                              <Paper>
                                <MenuList
                                  autoFocusItem={open}
                                  id="menu-list-grow"
                                >
                                  {props.product.isBundle ? (
                                    <>
                                      <MenuItem
                                        onClick={() => {
                                          navigate(
                                            `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                                          );
                                        }}
                                      >
                                        {props.product.status !==
                                          "P_PUBLISHED" ? (
                                          <>
                                            <span
                                              style={{
                                                marginRight: ".5rem",
                                                display: "flex",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <EditIconNew />
                                            </span>
                                            <span style={{ fontSize: "14px" }}>
                                              {t("EDIT")}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span
                                              style={{
                                                display: "flex",
                                                marginRight: ".5rem",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <ViewIconNew />
                                            </span>
                                            <span
                                              style={{ fontSize: "0.8rem" }}
                                            >
                                              {t("VIEW")}
                                            </span>
                                          </>
                                        )}
                                      </MenuItem>
                                      {!props.tenantRoles.includes(
                                        "CHILD_PROVIDER",
                                      ) && (
                                          <MenuItem onClick={handlePushOffering}>
                                            <span
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <ExportIcon />
                                            </span>
                                            <span style={{ fontSize: "14px" }}>
                                              {t("PUSH_OFFERING")}
                                            </span>
                                          </MenuItem>
                                        )}
                                      <MenuItem
                                        onClick={() => {
                                          navigate(
                                            `/createSpecialPrice?packageId=${props.product.productId}&packageMode=promo`,
                                          );
                                        }}
                                      >
                                        <span
                                          style={{
                                            marginRight: ".5rem",
                                            display: "flex",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <EditSpecialPrice />
                                          {/* <svg
																							width="16"
																							height="16"
																							viewBox="0 0 21 21"
																							fill="currentColor"
																							xmlns="http://www.w3.org/2000/svg"
																						>
																							<circle cx="10.5" cy="10.5" r="10.5" />
																							<path
																								d="M10.5 0C4.70156 0 0 4.70156 0 10.5C0 16.2984 4.70156 21 10.5 21C16.2984 21 21 16.2984 21 10.5C21 4.70156 16.2984 0 10.5 0ZM11.0227 15.5906L11.0273 16.3336C11.0273 16.4367 10.943 16.5234 10.8398 16.5234H10.1742C10.0711 16.5234 9.98672 16.4391 9.98672 16.3359V15.6C7.90547 15.4453 6.92578 14.2594 6.82031 12.9703C6.81094 12.8602 6.89766 12.7664 7.00781 12.7664H8.09063C8.18203 12.7664 8.26172 12.832 8.27578 12.9211C8.39531 13.6641 8.97422 14.2195 10.0125 14.3578V11.0133L9.43359 10.8656C8.20781 10.5727 7.04062 9.80859 7.04062 8.22422C7.04062 6.51562 8.33906 5.59687 9.99844 5.43516V4.66172C9.99844 4.55859 10.0828 4.47422 10.1859 4.47422H10.8445C10.9477 4.47422 11.032 4.55859 11.032 4.66172V5.42813C12.6375 5.58984 13.8422 6.52734 13.9828 7.9875C13.9945 8.09766 13.9078 8.19375 13.7953 8.19375H12.743C12.6492 8.19375 12.5695 8.12344 12.5578 8.03203C12.4641 7.34766 11.9156 6.78984 11.0227 6.66797V9.81562L11.618 9.95391C13.1367 10.3289 14.1703 11.0555 14.1703 12.682C14.1703 14.4469 12.8578 15.4313 11.0227 15.5906ZM8.49844 8.11641C8.49844 8.71172 8.86641 9.17344 9.65859 9.45938C9.76875 9.50391 9.87891 9.53906 10.0102 9.57656V6.67031C9.14531 6.78047 8.49844 7.26562 8.49844 8.11641ZM11.2289 11.2852C11.1633 11.2711 11.0977 11.2547 11.0227 11.2336V14.3672C12.0211 14.2781 12.7102 13.7297 12.7102 12.8109C12.7102 12.0914 12.3375 11.6227 11.2289 11.2852Z"
																								fill="white"
																							/>
																						</svg> */}
                                        </span>
                                        <span style={{ fontSize: "14px" }}>
                                          {t("EDIT_SPECIAL_PRICING")}
                                        </span>
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() => {
                                          props.removeProduct(
                                            props.product.productId,
                                            props.productIndex,
                                          );
                                        }}
                                      >
                                        <span
                                          style={{
                                            marginRight: ".5rem",
                                            display: "flex",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <DeleteIconNew />
                                          {/* <svg
																							width="16"
																							height="16"
																							viewBox="0 0 21 21"
																							fill="currentColor"
																							xmlns="http://www.w3.org/2000/svg"
																						>
																							<circle cx="10.5" cy="10.5" r="10.5" />
																							<path
																								d="M10.5 0C4.704 0 0 4.704 0 10.5C0 16.296 4.704 21 10.5 21C16.296 21 21 16.296 21 10.5C21 4.704 16.296 0 10.5 0ZM15.75 11.55H5.25V9.45H15.75V11.55Z"
																								fill="white"
																							/>
																						</svg> */}
                                        </span>
                                        <span style={{ fontSize: "14px" }}>
                                          {t("REMOVE")}
                                        </span>
                                      </MenuItem>
                                    </>
                                  ) : (
                                    <MenuItem onClick={handleClose}>
                                      <span style={{ marginRight: "8px" }}>
                                        <svg
                                          width="13"
                                          height="12"
                                          viewBox="0 0 13 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          onClick={() => {
                                            props.editStandaloneProduct(
                                              props.product.componentId,
                                              props.product.componentType,
                                            );
                                          }}
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      <span style={{ fontSize: "14px" }}>
                                        {t("EDIT")}
                                      </span>
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Paper>
                            </ClickAwayListener>
                          </Popper>
                        </>
                      </React.Fragment>
                    ) : (
                      (props.userPerms.includes("CUMULATOR_CATALOG_VIEW") ||
                        props.userPerms.includes("CATALOG_VIEW")) && (
                        <React.Fragment>
                          {!props.product.sellable ? (
                            <Button
                              style={{ width: "100%" }}
                              // className={classes.button2}
                              className={"buttonSecondary"}
                              onClick={() => {
                                navigate(
                                  `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                                );
                              }}
                            >
                              <span style={{ marginRight: "8px" }}>
                                <ViewIconNew />
                              </span>
                              {t("VIEW")}
                            </Button>
                          ) : (
                            <Button
                              style={{ width: "100%" }}
                              // className={classes.button2}
                              className={"buttonSecondary"}
                              onClick={() => {
                                props.editStandaloneProduct(
                                  props.product.productId,
                                  props.product.productTypeId,
                                );
                              }}
                            >
                              <span style={{ marginRight: "8px" }}>
                                <ViewIconNew />
                              </span>
                              {t("VIEW")}
                            </Button>
                          )}
                        </React.Fragment>
                      )
                    )}
                  </>
                )
              ) : (
                // tab Available Solutions
                <React.Fragment>
                  <Tooltip title={t("ADD_TO_MY_SOLUTIONS")}>
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 21 21"
                      fill="none"
                      className="offeringTableIcons"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        navigate(
                          `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=true`,
                        );
                      }}
                    >
                      <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
                      <path
                        d="M17 10.8571H11.8571V16H10.1429V10.8571H5V9.14286H10.1429V4H11.8571V9.14286H17V10.8571Z"
                        fill={props.tenantData.color}
                      />
                    </svg>
                  </Tooltip>
                </React.Fragment>
              )
            ) : (
              <React.Fragment>
                {props.product.isBundle ? (
                  <Button
                    style={{ width: "35%" }}
                    className={classes.button2}
                    onClick={() => {
                      navigate(
                        `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                      );
                    }}
                  >
                    <span style={{ marginRight: "8px" }}>
                      <svg
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {t("EDIT")}
                  </Button>
                ) : (
                  <Button
                    style={{ width: "35%" }}
                    className={classes.button2}
                    onClick={() => {
                      props.editStandaloneProduct(
                        props.product.componentId,
                        props.product.componentType,
                      );
                    }}
                  >
                    <span style={{ marginRight: "8px" }}>
                      <svg
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {t("EDIT")}
                  </Button>
                )}
              </React.Fragment>
            )}
          </TableCell>
        )}
      </TableRow >
      <Dialog
        open={pushOfferingDialog}
        onClose={() => setPushOfferingDialog(false)}
        PaperComponent={DraggableDialogPaper}
        aria-labelledby="draggableDialogPaper"
        fullWidth={true}
        maxWidth={"sm"}
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          {t("PUSH_OFFERING_TO")}
        </DialogTitle>

        <DialogContent dividers>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <Loader loading={true} />
            </div>
          ) : childTenantsList.length > 0 ? (
            <>
              <div
                className="borderOutline roundCorners"
                style={{ display: "flex", flexDirection: "column" }}
              >
                {childTenantsList.map((tenant) => (
                  <FormControlLabel
                    key={tenant.tenantId}
                    control={
                      <Checkbox
                        checked={selectedTenants.includes(tenant.tenantId)}
                        onChange={() => handleTenantSelection(tenant.tenantId)}
                        color="primary"
                      />
                    }
                    label={tenant.tenantName}
                  />
                ))}
              </div>
            </>
          ) : (
            <DialogContentText>{t("NO_CHILD_TENANTS_FOUND")}</DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="buttonSecondary"
            onClick={() => {
              setPushOfferingDialog(false);
              setSelectedTenants([]);
            }}
          >
            {t("CANCEL")}
          </Button>
          <Button
            disabled={selectedTenants.length === 0}
            onClick={() => {
              pushOfferingToTenants(selectedTenants);
              setPushOfferingDialog(false);
            }}
          >
            {t("PUSH")}
          </Button>
        </DialogActions>
      </Dialog>
      <Loader loading={isLoading} />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    publicBrowsing: state.auth.publicBrowsing,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
    quoteEnabled: state.auth.quoteEnabled,
    tenantRoles: state.auth.tenantRoles,
  };
};
export default connect(mapStateToProps)(
  withTranslation("translations")(ProductTable),
);
